import { EmployeePBIcon, EnterprisePBIcon, HRPBIcon } from '@components/svgs';

export const WhyPerksBarContent = [
  {
    Svg: EmployeePBIcon,
    title: 'Employee',
    content:
      'Transform the employee experience with a dynamic rewards and recognition system, promoting satisfaction and engagement.',
  },
  {
    Svg: HRPBIcon,
    title: 'Human Resources',
    content:
      'Drive operational efficiency in internal communication by automating and digitizing HR initiatives like employee surveys, workshops, and data analytics.',
  },
  {
    Svg: EnterprisePBIcon,
    title: 'Enterprise',
    content:
      'Cultivate a positive culture, active participation in the company’s mission, and strong employee connections to drive organizational performance.',
  },
];

export default WhyPerksBarContent;
